import React from 'react';
import { Button, Collapse, Drawer, Empty, Spin, Tag, Timeline, Typography } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import { isMobile } from 'react-device-detect';
import { isValidDate } from '@/utils/helpers';
import { formatHistoryValue, prepareHistoryChange } from './receiptHistoryPresentation';

const { Panel } = Collapse;
const { Text } = Typography;

const actionColors = {
    receipt_created: 'green', receipt_updated: 'blue', allocation: 'cyan', balance_used: 'purple',
    apply: 'purple', receive: 'green', adjust: 'orange', refund: 'red', delete: 'red', receipt_cancelled: 'red', restore: 'green',
};

const ChangeRow = ({ change }) => {
    const displayChange = prepareHistoryChange(change);
    return (
        <div style={{ padding: '7px 0', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ color: '#595959', fontSize: 12, marginBottom: 3 }}>{displayChange.label}</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'baseline', whiteSpace: 'pre-wrap' }}>
                {!displayChange.singleValue && (
                    <>
                        <Text delete type="danger" style={{ wordBreak: 'break-word' }}>
                            {formatHistoryValue(displayChange.old, displayChange.type)}
                        </Text>
                        <Text type="secondary">→</Text>
                    </>
                )}
                <Text strong style={{ color: '#237804', wordBreak: 'break-word' }}>
                    {formatHistoryValue(displayChange.new, displayChange.type)}
                </Text>
            </div>
            {displayChange.note ? (
                <div style={{ color: '#8c8c8c', fontSize: 12, marginTop: 3, whiteSpace: 'pre-wrap' }}>
                    {formatHistoryValue(displayChange.note)}
                </div>
            ) : null}
        </div>
    );
};

const ReceiptHistoryDrawer = ({ visible, loading, items, onClose }) => {
    const meaningfulItems = (items || []).filter(item => Array.isArray(item.changes) && item.changes.length > 0);

    return (
    <Drawer
        visible={visible}
        title={<span><HistoryOutlined /> Lịch sử thay đổi phiếu thu</span>}
        onClose={onClose}
        maskClosable={false}
        width={isMobile ? '100%' : '52%'}
        bodyStyle={{ padding: isMobile ? 12 : 18 }}
    >
        <Spin spinning={loading}>
            {!meaningfulItems.length && !loading ? <Empty description="Chưa có lịch sử thay đổi" /> : (
                <Timeline>
                    {meaningfulItems.map(item => (
                        <Timeline.Item color={actionColors[item.action] || 'blue'} key={item.key}>
                            <Collapse bordered={false} style={{ background: '#fafafa' }}>
                                <Panel
                                    key={item.key}
                                    header={(
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
                                            <Tag color={actionColors[item.action] || 'blue'}>{item.summary}</Tag>
                                            <Text>{item.actor_name || 'Hệ thống'}</Text>
                                            <Text type="secondary">· {isValidDate(item.occurred_at, true)}</Text>
                                            <Text type="secondary">· {item.changes?.length || 0} thay đổi</Text>
                                        </div>
                                    )}
                                >
                                    {(item.changes || []).map((change, index) => <ChangeRow key={`${change.field}-${index}`} change={change} />)}
                                </Panel>
                            </Collapse>
                        </Timeline.Item>
                    ))}
                </Timeline>
            )}
        </Spin>
    </Drawer>
    );
};

export const ReceiptHistoryButton = ({ onClick }) => (
    <Button icon={<HistoryOutlined />} onClick={onClick}>Xem lịch sử</Button>
);

export default ReceiptHistoryDrawer;
